/* eslint-disable */
export default {
  ABOUT: "O službě",
  MAP: "Mapa",
  FAQ: "FAQ",
  CONTACT: "Kontakt",
  PARTNERS: "Partneři",
  LOGIN: "Přihlášení",
  TITLE1: "Provázejte návštěvníky",
  TITLE2: "jako nikdy předtím",
  DESC1: "Sdělte",
  DESC1_1: "co",
  DESC1_2: "kdy",
  DESC1_3: "kde",
  DESC1_4: "jediným QR kódem.",
  AND: "a",
  DESC2: "Profesionální řešení dostupné pro každého",
  ACTION1: "DOMLUVENÍ UKÁZKY",
  ACTION2: "Samostatné vytvoření",
  DEMO1: "Demo: Síť chat",
  DEMO2: "Demo: Zábavní park",
  DEMO3: "Demo: Veletrh práce",
  DEMO4: "Demo: Konference",
  DEMO1_TITLE: "TURISMUS",
  DEMO2_TITLE: "PARKY",
  DEMO3_TITLE: "AKCE",
  DEMO4_TITLE: "MÍSTA",
  BOX1_TITLE: "Pohodlí",
  BOX1_DESC: "Dopřejte návštěvníkům perfektní zážitek bez instalace aplikace",
  BOX2_TITLE: "Rychlost",
  BOX2_DESC:
    "Mějte vše připraveno během několika okamžiků a ušetřete čas s organizací",
  BOX3_TITLE: "Síla",
  BOX3_DESC:
    "Snadno vytvářejte nejlepší aplikace a interaktivní mapy pro své návštěvníky",
  ECO1: "Tiskněte méně",
  ECO1_DESC:
    "Každý den se použijí a vyhodí miliony letáků. Vyzkoušejte nyní naše digitální řešení",
  MAP_TITLE: "Interaktivní mapa",
  MAP_DESC: "Vytvořte nejlepší mapy na internetu v našem nástroji",
  MAP_DESC2: "Můžete zobrazit cokoli",
  MAP_TYPE1: "KLASICKÁ",
  MAP_TYPE2: "VNITŘNÍ",
  MAP_TYPE3: "UMĚLECKÁ",
  MAP_TYPE4: "OBRÁZKOVÁ",
  TRY_ACTION: "VYZKOUŠET",
  FREQUENTLY_ASKED_QUESTIONS: "Časté dotazy",
  FAQ_DESC1: "Podívejte se, na co se ptají organizátoři akcí a manažeři míst.",
  FAQ_DESC2: "Neváhejte nás kontaktovat pro další dotazy",
  Q1: "Co toto řešení dělá jedinečným?",
  A1: "Celé řešení působí jako nativní aplikace, ale nevyžaduje instalaci. Rovněž je to doplněno tím nejlepším nástrojem pro tvorbu interaktivní map na trhu. Vytváření profesionálně vypadajících aplikací a interaktivních map bylo omezeno na firmy s velkými rozpočty. Nyní si vše můžete udělat sami. Již během pár okamžiků si budete schopni vytvořit dokonalého průvodce a vizualizaci pro své návštěvníky.",
  Q2: "Je moje akce/místo dost velké pro toto řešení?",
  A2: "Naše řešení se hodí všude tam, kde přemýšlíte nad tím, jak návštěvníky nejlépe nasměrovat. Všechny funkce Mapheimu jsou volitelné, takže jej můžete použít například jen k zobrazení programu a základních informací. A pokud se vaše akce nebo místo konání rozroste, můžete později použít další funkce.",
  Q3: "Můžu použít interaktivní mapu bez aplikace?",
  A3: "Ano, můžete si vytvořit interaktivní mapu a poté ji vložit do stávající webové stránky nebo aplikace. Můžete ji také použít jako samostatný produkt, záleží jen na vás.",
  Q4: "Kdy to bude a za kolik?",
  A4: "Svojí první aplikaci můžete mít hotovou za pár minut v našem editoru. Také nátroj na tvorbu interaktivních map je volně k dispozici, ale obvykle s ním pomáháme našim zákazníkům, abychom vytvořili tu nejlepší možnou mapu. Cena závisí především na počtu návštěvníků, typu akce a množství pomoci z naší strany.  Kontaktujte nás, abychom mohli probrat váš případ.",
  Q5: "Jak se to liší od klasické webové stránky?",
  A5: "Je rozdíl mezi využíváním webových stránek k přilákání návštěvníků na vaše místo oproti jejich provázením, když už tam jsou. Máte příležitost poskytnout jim co nejlepší zážitek, a to tak, že jim strukturovaně poskytnete správné informace a případně prodáte další služby. Mapheim je pro tento případ použití zcela optimalizován a lze jej perfektně používat na mobilních zařízeních.",
  CONTACT_TITLE: "Kontakt",
  CONTACT_HELLO: "Pozdravte Honzu",
  CONTACT_DESC:
    "Může odpovědět na vaše dotazy a pomoci vám nastavit vaši první aplikaci a mapu",
  EMAIL: "Email",
  EMAIL_NOT_VALID: "Email není platný",
  MESSAGE: "Zpráva",
  SEND_ACTION: "ODESLAT",
  MESSAGE_RECEIVED: "Děkujeme za vaši zprávu, brzy vás budeme kontaktovat",
  MESSAGE_ERROR:
    "Bohužel jsme nemohli odeslat vaši zprávu. Kontaktujte mě přímo přes Linkedin nebo email.",
  CUSTOMERS_TITLE: "Zákazníci",
  NORWAY: "Norsko",
  DENMARK: "Dánsko",
  CZECHIA: "Česko",
  SLOVAKIA: "Slovensko",
  FAROE_ISLANDS: "Faerské ostrovy",
  PARTNERS_TITLE: "Partneři",
  TRONDHEIM_ON_MAP: "Mapa Trondheimu",
  FOOTER1: "Získejte dneska",
  FOOTER2: "aplikaci a mapu",
  MADE_IN_NORWAY: "VYROBENO V NORSKU",
  ADMIN_CALL: "Přihlášení",
  TRIAL_ACCESS: "Zkušební přístup",
}
